import type { ReactNode } from "react";
import { ChakraBox as Box } from "@airhelp/react-ui-components";
import { customClassNames } from "./customClassNames.config";

const Styled = ({ children, className }: { children: ReactNode; className: string }) => (
  <Box sx={customClassNames} as="span">
    <Box as="span" className={className}>
      {children}
    </Box>
  </Box>
);

export default Styled;
